/**
 * # Button CTA Rebrand
 */

/**
 * ## Imports
 */
import './ButtonCtaRebrand.scss';

/**
 * ## Component
 * @param {string} label
 * @param {string} classList
 * @param {boolean} layoutBig
 * @param {boolean} layoutReduced
 * @param {boolean} layoutDry
 * @param {boolean} layoutLofty
 * @param {boolean} layoutGlowBottom
 * @param {boolean} arrowIndicator
 * @returns React
 */
const ButtonCtaRebrand = ({
    label = 'text',
    classList = '',
    layoutBig = false,
    layoutReduced = false,
    layoutDry = false,
    layoutLofty = false,
    layoutGlowBottom = false,
    arrowIndicator = false,
    fullWidth = false,
    large = false,
    isAnimated = false,
    onClick = () => {},
}) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={`button-cta-rebrand
            ${layoutBig ? ` button-cta-rebrand--big` : ''}
            ${layoutReduced ? ` button-cta-rebrand--reduced` : ''}
            ${arrowIndicator ? ` button-cta-rebrand--arrow` : ''}
            ${isAnimated ? ` button-cta-rebrand--animated-arrow` : ''}
            ${arrowIndicator && large ? ` button-cta-rebrand--arrow-large` : ''}
            ${layoutDry ? ` button-cta-rebrand--dry` : ''}
            ${layoutLofty ? ` button-cta-rebrand--lofty` : ''}
            ${large ? ` button-cta-rebrand--large` : ''}
            ${fullWidth ? ` button-cta-rebrand--full-width` : ''}
            ${layoutGlowBottom ? ` button-cta-rebrand--glow-bottom` : ''}
            ${classList ? classList : ''}`}
        >
            <span className="button-cta__body">{label}</span>
        </button>
    );
};

export default ButtonCtaRebrand;
